import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MegaMenu, Footer, ToastProvider, ToastContainer, initTheme } from '@watkinslabs/watkinsx-components';
import '@watkinslabs/watkinsx-components/dist/index.css';
import './App.css';
import './kizashi.css';
import './kizashi-sections.css';
import './kizashi-stage.css';
import {
  Hero, Example, WhyNow, Evidence, Platform, Trust, Deploy, Status, Cta,
} from './Exec';
import Console from './Console';
import Engineers from './Engineers';

// Section order: outcomes and evidence for the people who decide first, then the platform,
// governance and deployment, then the console and status, and the engineering depth last.
// Light and dark follow the shell's theme marker on <html>; kizashi.css holds the tokens.
function App() {
  useEffect(() => { initTheme(); }, []);
  return (
    <ToastProvider>
      <Router>
        <div className="App kz">
          <MegaMenu title="Kizashi" tagline="Signals ML platform" />
          <main className="app-content">
            <Hero />
            <Example />
            <WhyNow />
            <Evidence />
            <Platform />
            <Trust />
            <Deploy />
            <Console />
            <Status />
            <Cta />
            <Engineers />
            <p className="kz-license">Kizashi is MIT licensed. &copy; Watkins Labs</p>
          </main>
          <Footer />
          <ToastContainer />
        </div>
      </Router>
    </ToastProvider>
  );
}

export default App;
